// Size Expand/Collapse functionality for variant picker
(function() {
  const SIZE_LIMIT = 5;
  const processedContainers = new WeakSet();

  // Use a Map with a string key (parent element path) instead of WeakSet
  // This survives DOM recreation
  const expandedStates = new Map(); // Track expanded state by container ID

  // Generate a unique ID for a container based on its position in the DOM
  function getContainerId(container) {
    // Use the fieldset legend text as a unique identifier
    const fieldset = container.closest('fieldset');
    if (fieldset) {
      const legend = fieldset.querySelector('legend');
      if (legend) {
        return legend.textContent.trim();
      }
    }
    // Fallback: use index in parent
    const parent = container.parentNode;
    const index = Array.from(parent.children).indexOf(container);
    return `container-${index}`;
  }

  function initializeSizeToggles() {
    const sizeContainers = document.querySelectorAll('.variant-picker__option-values[data-size-container]');
    console.log('🔍 Found', sizeContainers.length, 'size containers');

    sizeContainers.forEach(container => {
      // Get unique ID for this container
      const containerId = getContainerId(container);
      const wasExpandedBefore = expandedStates.get(containerId) || false;

      // Skip if already processed
      if (processedContainers.has(container)) {
        console.log('⏭️ Container', containerId, 'already processed, skipping (was expanded:', wasExpandedBefore, ')');
        return;
      }

      // Mark as processed immediately to prevent race conditions
      processedContainers.add(container);
      console.log('✅ Processing new container', containerId, '(was expanded before:', wasExpandedBefore, ')');

      // Count all direct child elements that are option elements AND have stock
      const sizeOptions = Array.from(container.children).filter(child => {
        // Check if it's a valid option element
        const isOption = child.matches('label, a, .block-swatch, .color-swatch, .thumbnail-swatch') ||
                        child.querySelector('label, a, .block-swatch, .color-swatch, .thumbnail-swatch');

        // Check if it's not already hidden (either by hidden attribute or display:none)
        // These are hidden because they're out of stock
        const isVisible = !child.hasAttribute('hidden') &&
                         child.style.display !== 'none' &&
                         !child.classList.contains('size-toggle-btn');

        return isOption && isVisible;
      });

      console.log('📦 All container children:', container.children.length);
      console.log('👀 Visible size options (with stock):', sizeOptions.length);

      console.log('📊 Found', sizeOptions.length, 'size options (limit:', SIZE_LIMIT + ')');

      if (sizeOptions.length <= SIZE_LIMIT) {
        console.log('⚠️ Not enough options, no toggle needed');
        return; // No need for toggle
      }

      // Check if this container was previously expanded (use same ID)
      const wasExpanded = expandedStates.get(containerId) || false;
      console.log('🔄 Was expanded?', wasExpanded, 'for', containerId);

      // Always create a fresh toggle button
      // Remove old button wrapper if it exists
      const oldWrapper = container.querySelector('.size-toggle-wrapper');
      if (oldWrapper) {
        console.log('🗑️ Removing old button wrapper');
        oldWrapper.remove();
      }

      // Create toggle button wrapper
      const toggleWrapper = document.createElement('div');
      toggleWrapper.className = 'size-toggle-wrapper';

      const toggleBtn = document.createElement('button');
      toggleBtn.type = 'button';
      toggleBtn.className = 'size-toggle-btn';
      toggleBtn.setAttribute('aria-expanded', wasExpanded ? 'true' : 'false');
      toggleBtn.innerHTML = `<span class="size-toggle-icon">${wasExpanded ? '−' : '+'}</span>`;

      toggleWrapper.appendChild(toggleBtn);

      // Insert button wrapper at the END of the container (always last)
      container.appendChild(toggleWrapper);
      console.log('➕ Toggle button created and inserted at end of container');

      // Hide extra options initially (unless container was expanded)
      sizeOptions.forEach((option, index) => {
        if (index >= SIZE_LIMIT) {
          option.classList.add('size-option-extra');
          option.setAttribute('data-extra-option', 'true');
          option.style.display = wasExpanded ? 'inline-block' : 'none';
        }
      });
      console.log('👁️ Set initial visibility for extra options');

      // Toggle handler
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('🖱️ Toggle button CLICKED!');

        const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
        console.log('📍 Current state:', isExpanded ? 'expanded' : 'collapsed');

        // Find all extra options (use the stored reference)
        const extraOptions = Array.from(container.querySelectorAll('[data-extra-option="true"]'));
        console.log('🔢 Found', extraOptions.length, 'extra options to toggle');

        extraOptions.forEach(option => {
          if (isExpanded) {
            option.style.display = 'none';
            console.log('  ➖ Hiding option');
          } else {
            option.style.display = 'inline-block';
            console.log('  ➕ Showing option with display: inline-block');
          }
        });

        // Update expanded state tracking using the container ID
        if (isExpanded) {
          expandedStates.set(containerId, false); // Mark as collapsed
          console.log('💾 Marked', containerId, 'as collapsed');
        } else {
          expandedStates.set(containerId, true); // Mark as expanded
          console.log('💾 Marked', containerId, 'as expanded');
        }

        toggleBtn.setAttribute('aria-expanded', !isExpanded);
        toggleBtn.querySelector('.size-toggle-icon').textContent = isExpanded ? '+' : '−';
        console.log('✨ Toggle complete, new state:', !isExpanded ? 'expanded' : 'collapsed');
      });
      console.log('🎯 Click listener added to toggle button');

      // Prevent closing on option click - add capture phase to ensure this runs first
      sizeOptions.forEach((option, index) => {
        option.addEventListener('click', function(e) {
          // Stop propagation in capture phase to prevent toggle from firing
          e.stopPropagation();
          const isExtra = index >= SIZE_LIMIT;
          console.log('🔘 Size option clicked (index:', index, 'isExtra:', isExtra, '), propagation stopped');
        }, true); // Use capture phase
      });
      console.log('🛡️ Added click protection to', sizeOptions.length, 'options (', (sizeOptions.length - SIZE_LIMIT), 'are extra)');
    });
  }

  // Initialize on different load events
  let isInitialized = false;

  function init() {
    if (isInitialized) {
      console.log('⏭️ Already initialized, skipping');
      return;
    }
    console.log('🚀 Starting initialization...');
    initializeSizeToggles();
    isInitialized = true;
    console.log('✅ Initialization complete');
  }

  // Single initialization strategy
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded, initialize immediately
    init();
  }

  // Watch for DOM changes (for dynamic content loading)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if the added node is a size container or contains one
          if (node.matches && node.matches('.variant-picker__option-values[data-size-container]')) {
            console.log('🔄 MutationObserver: New size container detected');
            initializeSizeToggles();
          } else if (node.querySelector && node.querySelector('.variant-picker__option-values[data-size-container]')) {
            console.log('🔄 MutationObserver: New size container detected in subtree');
            initializeSizeToggles();
          }
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
